'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import ConnectGmailInbox from 'InboxConnectUtils/ConnectGmailInbox';
import ConnectOutlook365Inbox from 'InboxConnectUtils/ConnectOutlook365Inbox';
import ConnectOutlook365GCCInbox from 'InboxConnectUtils/ConnectOutlook365GCCInbox';
import * as EmailClients from 'InboxConnectUtils/constants/EmailClients';
import { ICON_UNKNOWN_INBOX } from 'InboxConnectUtils/constants/Images';
import StepInterface from './StepInterface';
import { CHOOSE_PROVIDER_STEP, IMAP_INBOX_STEP, EXCHANGE_INBOX_STEP, CONNECT_INBOX_STEP, FAILURE_STEP, TEST_MESSAGE_STEP } from 'InboxConnectUtils/constants/InboxConnectStepKeys';
import InboxTypes from '../../constants/InboxTypes';
import WhatToExpect from './section/WhatToExpect';
import ConnectLegalDisclaimer from './section/ConnectLegalDisclaimer';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WIZARD_ROUTE = 'InboxConnectUtils.wizard';
const LANG_ROUTE = 'InboxConnectUtils.wizard.connectInbox.';
const DEFAULT_CLIENT = 'default';
const providerFormStep = {
  [EmailClients.imap.key]: IMAP_INBOX_STEP,
  [EmailClients.exchange.key]: EXCHANGE_INBOX_STEP
};
export default class ConnectInboxStep extends Component {
  constructor(...args) {
    super(...args);
    this.onClickChooseProviderLink = () => {
      this.props.trackingClient.trackStepAction(CONNECT_INBOX_STEP, 'clicked connect different account link');
      this.props.setShownStep(CHOOSE_PROVIDER_STEP);
    };
  }
  componentDidMount() {
    const selectedClient = this.props.selectedClient || DEFAULT_CLIENT;
    this.props.trackingClient.trackStepView(CONNECT_INBOX_STEP, selectedClient);
    if (this.props.skipConnectInboxStep) {
      this.handleConnectInboxClick();
    }
  }
  handleConnectInboxClick() {
    const {
      inboxType,
      setShownStep,
      portalId,
      oauthOptions,
      inboxCreateContext,
      selectedAutomation,
      service
    } = this.props;
    const selectedClient = this.props.selectedClient || DEFAULT_CLIENT;
    this.props.trackingClient.trackStepAction(CONNECT_INBOX_STEP, 'Click connect(connect-inbox-step)');
    const {
      outlook365,
      outlook365GccHigh
    } = EmailClients;
    const connectFailed = errorResponse => {
      const {
        error,
        payload
      } = errorResponse;
      if (error) {
        const {
          message = '',
          emailAddress = ''
        } = payload || {};
        this.props.setEmailAddress(emailAddress);
        this.props.setConnectError(message);
      }
      this.props.setShownStep(FAILURE_STEP);
    };
    const formStep = providerFormStep[selectedClient];
    if (formStep) {
      setShownStep(formStep);
    } else {
      let connector;
      if (selectedClient === outlook365.key) {
        connector = ConnectOutlook365Inbox;
      } else if (selectedClient === outlook365GccHigh.key) {
        connector = ConnectOutlook365GCCInbox;
      } else {
        connector = ConnectGmailInbox;
      }
      const isShared = inboxType === InboxTypes.SHARED;
      if (oauthOptions && oauthOptions.redirectUrl) {
        // For future use - data object to be passed through the system to
        // resume as expected after a redirect
        const context = inboxCreateContext || {};
        context.passthrough = {
          selectedAutomation
        };
        const redirectUrl = connector.getConnectInboxUrl(oauthOptions.redirectUrl, null, portalId, isShared, {
          useActionRedirect: true,
          inboxCreateContext: JSON.stringify(context)
        });
        window.location.href = redirectUrl;
        return;
      }
      if (this.props.onStateChange) {
        this.props.onStateChange({
          cancelable: false
        });
      }
      const storeConnectedAccount = ({
        payload
      }) => {
        this.props.setEmailAddress(payload.emailAddress);
        this.props.setConnectedAccount(payload);
      };
      const newWindow = window.open();
      connector.baseConnect(undefined, newWindow, portalId, isShared, {
        inboxCreateContext: inboxCreateContext && JSON.stringify(inboxCreateContext)
      }, service).then(response => {
        return storeConnectedAccount(response);
      }).then(() => {
        setShownStep(TEST_MESSAGE_STEP);
      }).catch(error => {
        connectFailed(error);
      }).finally(() => {
        if (newWindow && !newWindow.closed) {
          newWindow.close();
        }
      }).catch(err => {
        setTimeout(() => {
          throw err;
        });
      });
    }
  }
  renderConnectButton() {
    const {
      onCancel
    } = this.props;
    if (onCancel) {
      return /*#__PURE__*/_jsxs(ButtonWrapper, {
        justify: "center",
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: () => this.handleConnectInboxClick(),
          paddingInline: "300",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${WIZARD_ROUTE}.agree`
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          onClick: () => onCancel(),
          "data-test-id": "wizard-cancel-button",
          paddingInline: "300",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${WIZARD_ROUTE}.cancel`
          })
        })]
      });
    }
    return /*#__PURE__*/_jsx(Button, {
      use: "primary",
      onClick: () => this.handleConnectInboxClick(),
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${WIZARD_ROUTE}.continue`
      })
    });
  }
  renderImage() {
    const logoNames = {
      gmail: EmailClients.GMAIL_LOGO_NAME,
      outlook365: EmailClients.OUTLOOK_LOGO_NAME,
      outlook365GccHigh: EmailClients.OUTLOOK_LOGO_NAME,
      exchange: EmailClients.EXCHANGE_LOGO_NAME
    };
    const {
      setShownStep,
      restrictProvider
    } = this.props;
    const selectedClient = this.props.selectedClient || DEFAULT_CLIENT;
    const chooseLink = /*#__PURE__*/_jsx(Link, {
      display: "block",
      onClick: () => {
        setShownStep(CHOOSE_PROVIDER_STEP);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${LANG_ROUTE}${selectedClient}.chooseLink`
      })
    });
    const chooseProviderTooltip = !restrictProvider && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: `${LANG_ROUTE}${selectedClient}.providerDetected`,
        options: {
          chooseLink
        }
      }),
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: "info",
        size: "xxs",
        color: "icon-core-subtle",
        marginInline: "100"
      })
    });
    return /*#__PURE__*/_jsxs(View, {
      marginBlock: "400",
      children: [logoNames[selectedClient] ? /*#__PURE__*/_jsx(Logo, {
        name: logoNames[selectedClient],
        blockSize: "40px"
      }) : /*#__PURE__*/_jsx(Image, {
        marginBlock: "200",
        src: ICON_UNKNOWN_INBOX,
        responsive: false,
        blockSize: "40px"
      }), /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(Text, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}${selectedClient}.label`
          })
        }), chooseProviderTooltip]
      })]
    });
  }
  render() {
    const {
      restrictProvider,
      emailAddress,
      whatToExpectDescription,
      service,
      skipConnectInboxStep
    } = this.props;
    if (skipConnectInboxStep) {
      return null;
    }
    const selectedClient = this.props.selectedClient || DEFAULT_CLIENT;
    const chooseDifferentProviderButton = /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Link, {
        onClick: this.onClickChooseProviderLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${LANG_ROUTE}chooseOther`
        })
      })
    });
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      textAlign: "center",
      "data-selenium": "connect-inbox-step",
      children: /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${LANG_ROUTE}${selectedClient}.title`
          })
        }), this.renderImage(), /*#__PURE__*/_jsx(Text, {
          as: "strong",
          children: emailAddress
        }), !restrictProvider && chooseDifferentProviderButton, /*#__PURE__*/_jsxs(View, {
          textAlign: "start",
          marginBlockStart: "400",
          children: [/*#__PURE__*/_jsx(WhatToExpect, {
            content: whatToExpectDescription
          }), /*#__PURE__*/_jsx(ConnectLegalDisclaimer, {
            selectedClient: selectedClient,
            service: service
          })]
        }), this.renderConnectButton()]
      })
    });
  }
}
ConnectInboxStep.propTypes = StepInterface;